import { Component, OnInit } from '@angular/core'
import { ToastrModule, ToastrService } from 'ngx-toastr'
import { ReactiveFormsModule } from '@angular/forms'
import { CommonModule } from '@angular/common'
import { MatDialog, MatDialogModule } from '@angular/material/dialog'
import { ConfirmationDialogComponent } from '../../../shared/components/confirmation-dialog/confirmation-dialog.component'
import { DatatableComponent } from '../../../shared/components/master-datatable/master-datatable.component'
import { MasterAddUpdateDialogComponent } from '../../../shared/components/master-add-update-dialog/master-add-update-dialog.component'
import { QuotationCloseReasonModel } from './quotationCloseReason.model'
import { QuotationCloseReasonService } from './quotationCloseReason.service'
import { MasterDatabaseDisplayModel } from '../../../shared/master-database-display.model'
import { MasterCommonServices } from '../../quotation/master.common.service'

@Component({
  selector: 'app-quotationclosereason.master',
  standalone: true,
  imports: [
    ToastrModule,
    ReactiveFormsModule,
    CommonModule,
    DatatableComponent,
  ],
  templateUrl: './quotationCloseReason.master.component.html',
  styleUrl: './quotationCloseReason.master.component.css',
})
export class QuotationCloseReasonMasterComponent {
  quotationclosereasonColumns: MasterDatabaseDisplayModel[] = [
    {
      key: 'quotationCloseReason',
      displayName: 'Quotation Close Reason Name',
      hiddenDataTable: false,
      hiddenDialog: false,
      type: 'text',
    },
    {
      key: 'addedOn',
      displayName: 'Added Date',
      hiddenDataTable: false,
      hiddenDialog: true,
      type: 'date',
    },
    {
      key: 'id',
      displayName: 'Id',
      hiddenDataTable: true,
      hiddenDialog: true,
      type: 'text',
    },
  ]
  isLoading: boolean = false

  constructor(
    private quotationclosereasonService: QuotationCloseReasonService,
    private toastr: ToastrService,
    private dialog: MatDialog,
    public masterCommonService: MasterCommonServices,
  ) {}

  openAddUpdateQuotationCloseReasonDialog(
    mode: string,
    quotationclosereason?: QuotationCloseReasonModel,
  ): void {
    const fields = this.quotationclosereasonColumns
    const dialogRef = this.dialog.open(MasterAddUpdateDialogComponent, {
      data: { item: quotationclosereason || {}, mode, fields },
    })

    dialogRef.afterClosed().subscribe((result) => {
      

      if (result) {
        if (mode === 'update') {
          this.updateQuotationCloseReason(result)
        } else {
          this.addQuotationCloseReason(result)
        }
      }
    })
  }

  addQuotationCloseReason(quotationclosereason: any): void {
    this.quotationclosereasonService
      .addQuotationCloseReason(quotationclosereason)
      .subscribe({
        next: () => {
          this.toastr.success(
            'Quotation Close Reason Added Successfully!',
            'Success',
          )
          this.masterCommonService.getAllQuotationCloseReasons()
        },
        error: (error: any) => {
          this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
        },
      })
  }

  updateQuotationCloseReason(quotationclosereason: any): void {
    this.quotationclosereasonService
      .updateQuotationCloseReason(quotationclosereason)
      .subscribe({
        next: () => {
          this.toastr.success(
            'Quotation Close Reason Updated Successfully!',
            'Success',
          )
          this.masterCommonService.getAllQuotationCloseReasons()
        },
        error: (error: any) => {
          this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
        },
      })
  }

  deleteQuotationCloseReason(
    quotationclosereason: QuotationCloseReasonModel,
  ): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: 'Are you sure you want to delete this quotation close reason?',
      },
    })
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        quotationclosereason.isDeleted = true
        this.quotationclosereasonService
          .deleteQuotationCloseReason(quotationclosereason)
          .subscribe({
            next: () => {
              this.masterCommonService.quotationCloseReasonsList = this.masterCommonService.quotationCloseReasonsList.filter(
                (p) => p.id !== quotationclosereason.id,
              )
              this.toastr.success(
                'Quotation Close Reason Deleted Successfully!',
                'Success',
              )
            },
            error: (error: any) => {
              this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
            },
          })
      }
    })
  }
}
